import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8l-4 4l4 4","key":"svg-0"}],["path",{"d":"M17 8l4 4l-4 4","key":"svg-1"}],["path",{"d":"M3 12l18 0","key":"svg-2"}]]

/**
 * IconArrowsHorizontal
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3dzLWhvcml6b250YWwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgOGwtNCA0bDQgNCIgLz4KICA8cGF0aCBkPSJNMTcgOGw0IDRsLTQgNCIgLz4KICA8cGF0aCBkPSJNMyAxMmwxOCAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrows-horizontal
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowsHorizontal = createReactComponent('outline', 'arrows-horizontal', 'ArrowsHorizontal', __iconNode);

export default IconArrowsHorizontal;